/**
 * Loại báo cáo trong xuất khẩu
 */
export const ReportTypeInExport = {
  /**
   * Động
   */
  DynamicReport: 1,

  /**
   * Tĩnh
   */
  StatisReport: 2
}

/**
 * Loại dùng cho xuất khẩu
 */
 export const ExportType = {
  /**
   * tinh hinh su dung
   */
  UseState_MyOrgAndOperateByMe: 1,

  /**
   * tinh hinh thuc hien cong viec
   */
  StateExecuteWork_MyOrgAndOperateByMe: 2,

  /**
   * thong ke cong viec theo loai viec
   */
  StatisticsByWorkType_MyOrgAndOperateByMe: 3,

  /**
   * so sanh tinh hinh thuc hien cong viec
   */
  CompareStateExecuteWork_MyOrgAndOperateByMe: 4,
  // của tôi

  /**
   * tinh hinh thuc hien cong viec
   */
  WorkStateOverviewByRoleAndWorkType_Personality: 5,

  /**
   * thong ke cong viec theo loai viec
   */
  StatisticsByWorkType_Personality: 6,

  /**
   * so sanh tinh hinh thuc hien cong viec
   */
  CompareStateExecuteWork_Personality: 7,

  /**
   * danh gia tinh hinh thuc hien cong viec
   */
  WorkStateToEvaluate_Personality: 8,

  // danh sách công việc

  /**
   * danh sach cong viec
   */
  TaskList: 9,

  /// <summary>
  /// cơ cấu coong việc theo loại việc_ đơn vị tôi/chủ quản
  /// </summary>
  StructureByWorkType_MyOrgAndOperateByMe : 10,

  /// <summary>
  /// Tình hình công việc theo loại việc
  /// </summary>
  StateByWorkType_MyOrgAndOperateByMe : 11,
  /// <summary>
  /// tổng quan tình hình công việc_ đơn vị tôi/chủ quản
  /// </summary>
  WorkState_MyOrgAndOperateByMe : 12,
}

/**
 * Align
 */
export const ExportAlign = {
  /**
   * Dưới
   */
  Bottom: 0,

  /**
   * Giữa
   */
  Center: 1,

  /**
   * Giữa
   */
  CenterAcross: 2,

  /**
   * ???
   */
  Distributed: 3,

  /**
   * Fill
   */
  Fill: 4,

  /**
   * ???
   */
  General: 5,

  /**
   * ???
   */
  Justify: 6,

  /**
   * ???
   */
  Left: 7,

  /**
   * ???
   */
  Right: 8,

  /**
   * ???
   */
  Top: 9,

  /**
   * ???
   */
  JustifiedLow: 10,

  /**
   * ???
   */
  ThaiDistributed: 11
}

export const ExportDataType = {
  /**
   * mặc định
   */
  DefaultType: 0,

  /**
   * Số lượng
   */
  QuantityType: 1,

  /**
   * đơn giá
   */
  UnitPriceType: 2,

  /**
   * thành tiền
   */
  CurrencyType: 3,

  /**
   * kiểu ngày
   */
  DateType: 4,

  /**
   * kiểu ngày giờ
   */
  DateTimeType: 5,

  /**
   * Kiểu tháng năm
   */
  MonthYearType: 22,

  /**
   * Năm
   */
  YearType: 6,

  /**
   * Kiểu giờ
   */
  TimeType: 7,

  /**
   * kiểu số
   */
  NumberType: 8,

  /**
   * Kiểu bool checkbox
   */
  CheckBoxType: 9,

  /**
   * Kiểu hyperlink
   */
  HyperLinkType: 10,

  /**
   * phần trăm
   */
  PercentType: 11,

  /**
   * kiểu liệt kê
   */
  EnumType: 12,

  /**
   * Hệ số tỉ lệ
   */
  ExchangeRateType: 13,

  /**
   * sắp xếp
   */
  SortOrderType: 14,

  /**
   * Không định dạng
   */
  NoFormat: 15,

  /**
   * Kiểu combobox
   */
  ComboboxType: 16,
  /**
   * Kiểu email
   */
  EmailType: 17,
  /**
   * kiểu số thập phân
   */
  DecimalType: 18,

  /**
   * Kiểu Chọn nhiều
   */
  MultiSelectType: 19,

  /**
   * Công thức
   */
  Formula: 20,

  /**
   * Html
   */
  TextHTML: 21,
}

export const ExportStatus = {
  InProcessing: 1,
  Success: 2,
  Fail: 3
}